import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { searchProductAPI } from './thunk';

export const initialState = {
  search: '',
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    updateSearch: (state, action: PayloadAction<string>) => {
      state.search = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Orders
    builder.addCase(searchProductAPI.fulfilled, (state: any, action: any) => {
      state.products = [
        ...state.products,
        ...(action.payload?.featured || []),
        ...(action.payload?.upstream || []),
      ];
    });
  },
});

export const { updateSearch } = reportSlice.actions;

export default reportSlice.reducer;
